import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    Typography,
    Button,
    Checkbox,
    FormControlLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Switch,
    Tooltip
} from '@mui/material';

import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, IconButton } from '@mui/material';

import { IconEdit, IconDeviceFloppy, IconChevronRight } from '@tabler/icons';
import {
    IconArrowLeft,
    IconRobot,
    IconSettings,
    IconHeadset,
    IconPlus,
    IconUser,
    IconTool,
    IconWorld,
    IconBolt,
    IconCalendar,
    IconTrash,
    IconX,
    IconPlugConnected,
    IconArrowsRightLeft,
    IconActivity
} from '@tabler/icons';

import { IconFileUnknownFilled } from '@tabler/icons-react';

import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import api from '../../../../services/api';

const hostname = window.location.hostname;
let AGENT_SERVER;

// if (hostname.startsWith('crm.')) {
//     AGENT_SERVER = 'https://apichat.loged.com.br';
// } else {
//     AGENT_SERVER = 'http://127.0.0.1:7000';
// }
if (hostname.startsWith('crm.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('glazzbeauty.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('casamathiola.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('bliveinpets.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('acin.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('braza55.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('po.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('florestavet.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('quimicer.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('imobiliaria.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else {
    AGENT_SERVER = 'http://127.0.0.1:7000';
}
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'https://apichat.loged.com.br';

const agentApi = axios.create({
    baseURL: AGENT_SERVER
});

agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

const AGENT_TYPES = {
    client_chatbot: {
        label: 'Chatbot Cliente Externo',
        color: '#1565c0',
        bg: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
        border: '#90caf9',
        Icon: IconRobot
    },
    admin_chatbot: {
        label: 'Chatbot Administrador',
        color: '#6a1b9a',
        bg: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
        border: '#ce93d8',
        Icon: IconUser
    },
    attendant_chatbot: {
        label: 'Chatbot Atendente',
        color: '#00695c',
        bg: 'linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%)',
        border: '#80cbc4',
        Icon: IconHeadset
    },
    system: {
        label: 'Agente de Sistema',
        color: '#bf360c',
        bg: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
        border: '#ffcc80',
        Icon: IconSettings
    }
};

const TRIGGER_TYPE_OPTIONS = [
    { value: 'always', label: 'Sempre (independente da mensagem)' },
    { value: 'keywords', label: 'Palavras-chave' },
    { value: 'regex', label: 'Expressão regular (regex)' }
];

const RULE_DEFAULT_FORM = {
    name: '',
    from_state: '',
    trigger_type: 'always',
    trigger_value: '',
    force_tool: '',
    to_state: '',
    order: 0,
    enabled: true
};

//? Workflow (máquina de estados configurável - Fase 7)
const CONDITION_TYPE_OPTIONS = [
    { value: 'always', label: 'Sempre', needsKey: false, needsValue: false },
    {
        value: 'message_keywords',
        label: 'Palavras-chave na mensagem',
        needsKey: false,
        needsValue: true,
        valueHint: 'palavras separadas por vírgula'
    },
    { value: 'message_regex', label: 'Expressão regular na mensagem', needsKey: false, needsValue: true, valueHint: 'padrão regex' },
    { value: 'variable_equals', label: 'Variável da conversa igual a', needsKey: true, needsValue: true, valueHint: 'valor esperado' },
    { value: 'variable_exists', label: 'Variável da conversa existe', needsKey: true, needsValue: false },
    { value: 'flag_equals', label: 'Flag da conversa igual a', needsKey: true, needsValue: true, valueHint: 'true, false ou texto' },
    { value: 'tool_executed', label: 'Tool já foi executada', needsKey: true, needsValue: false }
];

const WORKFLOW_STATE_DEFAULT_FORM = { name: '', description: '', order: 0, is_initial: false, is_final: false };
const WORKFLOW_TRANSITION_DEFAULT_FORM = { from_state: '', to_state: '', name: '', priority: 0, force_tool: '', enabled: true };

const ViewDetailAgents = () => {
    const { id } = useParams();

    const history = useHistory();

    const [agent, setAgent] = useState(null);
    const [tools, setTools] = useState([]);
    const [loading, setLoading] = useState(true);

    const [editingToolId, setEditingToolId] = useState(null);

    const [toolDraft, setToolDraft] = useState({});

    const [savingTool, setSavingTool] = useState(false);

    const [uploading, setUploading] = useState(false);
    const [deletingDocumentoId, setDeletingDocumentoId] = useState(null);

    const [documentos, setDocumentos] = useState([]);

    const [editingAgent, setEditingAgent] = useState(false);

    const [agentForm, setAgentForm] = useState({
        name: '',

        system_prompt: '',

        agent_type: ''
    });

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    const [appId, setAppId] = useState(null);
    const [allAgents, setAllAgents] = useState([]);
    const [canais, setCanais] = useState([]);
    const [savingCanalId, setSavingCanalId] = useState(null);

    //? Regras de Fluxo (state machine do orquestrador de ferramentas)
    const [rules, setRules] = useState([]);
    const [openRuleDialog, setOpenRuleDialog] = useState(false);
    const [editingRuleId, setEditingRuleId] = useState(null);
    const [ruleForm, setRuleForm] = useState(RULE_DEFAULT_FORM);
    const [savingRule, setSavingRule] = useState(false);
    const [savingRuleEnabledId, setSavingRuleEnabledId] = useState(null);

    //? Workflow (máquina de estados configurável - Fase 7)
    const [workflow, setWorkflow] = useState(null);
    const [creatingWorkflow, setCreatingWorkflow] = useState(false);

    const [openStateDialog, setOpenStateDialog] = useState(false);
    const [editingStateId, setEditingStateId] = useState(null);
    const [stateForm, setStateForm] = useState(WORKFLOW_STATE_DEFAULT_FORM);
    const [savingState, setSavingState] = useState(false);

    const [openTransitionDialog, setOpenTransitionDialog] = useState(false);
    const [editingTransitionId, setEditingTransitionId] = useState(null);
    const [transitionForm, setTransitionForm] = useState(WORKFLOW_TRANSITION_DEFAULT_FORM);
    const [transitionConditions, setTransitionConditions] = useState([]);
    const [savingTransition, setSavingTransition] = useState(false);

    useEffect(() => {
        carregarDados();
    }, []);

    const carregarCanais = async (currentAppId) => {
        try {
            const response = await api.get(`v1/apps/${currentAppId}/integrations/`);
            setCanais(response.data?.integrations || []);
        } catch (error) {
            console.error(error);
        }
    };

    const carregarDados = async () => {
        setLoading(true);

        try {
            const appResponse = await api.get('v1/apps/default/');

            const currentAppId = appResponse.data?.app?.id;
            const accountId = appResponse.data?.app?.account;

            setAppId(currentAppId);

            const agentsResponse = await agentApi.get(`/agent/api/v1/account/${accountId}/app/${currentAppId}/agents/`);

            const listaAgentes = agentsResponse.data?.agents || [];
            setAllAgents(listaAgentes);

            const agentFound = listaAgentes.find((a) => String(a.id) === String(id));

            if (!agentFound) {
                setStatus({
                    type: 'error',
                    message: 'Agente não encontrado.'
                });

                return;
            }

            setAgent(agentFound);

            setAgentForm({
                name: agentFound.name || '',
                system_prompt: agentFound.system_prompt || '',
                agent_type: agentFound.agent_type || ''
            });

            const toolsResponse = await agentApi.get(`/agent/api/v1/agent/${id}/aitools/`);

            setTools(toolsResponse.data?.tools || []);

            const rulesResponse = await agentApi.get(`/agent/api/v1/agent/${id}/rules/`);

            // Aceita tanto `{rules: [...]}` (mesmo padrão de `{tools: [...]}`/
            // `{agents: [...]}` já usados pelos outros endpoints desse backend)
            // quanto o array puro, pra não quebrar se vier num formato ou noutro.
            const listaRegras = rulesResponse.data?.rules || (Array.isArray(rulesResponse.data) ? rulesResponse.data : []);
            setRules(listaRegras);

            // Workflow (Fase 7) - usa o primeiro (mais antigo) workflow do agente, se
            // existir; o backend segue a mesma convenção ao decidir qual está "ativo".
            const workflowsResponse = await agentApi.get(`/agent/api/v1/agent/${id}/workflows/`);
            const listaWorkflows = workflowsResponse.data?.workflows || [];

            if (listaWorkflows.length > 0) {
                const workflowDetalhe = await agentApi.get(`/agent/api/v1/agent/${id}/workflows/${listaWorkflows[0].id}/`);
                setWorkflow(workflowDetalhe.data);
            } else {
                setWorkflow(null);
            }

            await carregarCanais(currentAppId);
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao carregar detalhes do agente.'
            });
        } finally {
            setLoading(false);
        }
    };

    const nomeDoAgenteResponsavel = (agentId) => {
        const outroAgente = allAgents.find((a) => String(a.id) === String(agentId));
        return outroAgente?.name || 'outro agente';
    };

    const toggleCanal = async (canal) => {
        const atribuidoAEsteAgente = String(canal.webhook_agent_id || '') === String(id);
        const novoValor = atribuidoAEsteAgente ? null : id;

        setSavingCanalId(canal.id);

        try {
            await api.patch(`v1/apps/${appId}/integrations/${canal.id}/`, {
                webhook_agent_id: novoValor
            });

            setCanais((prev) => prev.map((c) => (c.id === canal.id ? { ...c, webhook_agent_id: novoValor } : c)));
        } catch (error) {
            console.error(error);

            if (error.response?.status === 409) {
                setStatus({
                    type: 'error',
                    message: `Esse canal já está atribuído a outro agente (${nomeDoAgenteResponsavel(error.response.data?.current_webhook_agent_id)}).`
                });
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao atualizar o canal.'
                });
            }
        } finally {
            setSavingCanalId(null);
        }
    };

    const salvarAgente = async () => {
        try {
            await agentApi.patch(`/agent/api/v1/agent/${id}/`, agentForm);

            setAgent({
                ...agent,
                ...agentForm
            });

            setEditingAgent(false);

            setStatus({
                type: 'success',
                message: 'Agente atualizado com sucesso.'
            });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao atualizar agente.'
            });
        }
    };

    const iniciarEdicaoTool = (tool, e) => {
        e.stopPropagation();

        setEditingToolId(tool.id);

        setToolDraft({
            name: tool.name || '',
            description: tool.description || '',
            prompt: tool.prompt || '',
            endpoint: tool.endpoint || ''
        });
    };

    const cancelarEdicaoTool = (e) => {
        e.stopPropagation();

        setEditingToolId(null);

        setToolDraft({});
    };

    const salvarTool = async (toolId, e) => {
        e.stopPropagation();

        setSavingTool(true);

        try {
            await agentApi.patch(`/agent/api/v1/aitools/${toolId}/`, toolDraft);

            setTools((prev) => prev.map((t) => (t.id === toolId ? { ...t, ...toolDraft } : t)));

            setEditingToolId(null);

            setToolDraft({});

            setStatus({
                type: 'success',
                message: 'Ferramenta atualizada com sucesso.'
            });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao atualizar ferramenta.'
            });
        } finally {
            setSavingTool(false);
        }
    };

    const excluirTool = async (toolId, e) => {
        e.stopPropagation();

        const confirmar = window.confirm('Deseja realmente excluir esta ferramenta?');

        if (!confirmar) return;

        try {
            await agentApi.delete(`/agent/api/v1/aitools/${toolId}/`);

            setTools((prev) => prev.filter((t) => t.id !== toolId));

            setStatus({
                type: 'success',
                message: 'Ferramenta excluída com sucesso.'
            });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao excluir ferramenta.'
            });
        }
    };

    //? -------- Regras de Fluxo --------
    const regrasOrdenadas = [...rules].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    const abrirCriarRegra = () => {
        setEditingRuleId(null);
        setRuleForm({ ...RULE_DEFAULT_FORM, order: rules.length });
        setOpenRuleDialog(true);
    };

    const abrirEditarRegra = (rule) => {
        setEditingRuleId(rule.id);
        setRuleForm({
            name: rule.name || '',
            from_state: rule.from_state || '',
            trigger_type: rule.trigger_type || 'always',
            trigger_value: rule.trigger_value || '',
            force_tool: rule.force_tool || '',
            to_state: rule.to_state || '',
            order: rule.order ?? 0,
            enabled: rule.enabled !== false
        });
        setOpenRuleDialog(true);
    };

    const fecharDialogRegra = () => {
        setOpenRuleDialog(false);
        setEditingRuleId(null);
        setRuleForm(RULE_DEFAULT_FORM);
    };

    const regraValida = Boolean(ruleForm.name && ruleForm.from_state && ruleForm.to_state && ruleForm.force_tool);

    const salvarRegra = async () => {
        if (!regraValida) return;

        setSavingRule(true);

        // `trigger_value` só faz sentido pra keywords/regex - manda vazio
        // quando o gatilho é "always" (bate com o exemplo de configuração
        // pedido: "trigger_value": "" pra trigger_type "always").
        const payload = {
            ...ruleForm,
            trigger_value: ruleForm.trigger_type === 'always' ? '' : ruleForm.trigger_value,
            order: Number(ruleForm.order) || 0
        };

        try {
            if (editingRuleId) {
                await agentApi.patch(`/agent/api/v1/agent/${id}/rules/${editingRuleId}/`, payload);

                setRules((prev) => prev.map((r) => (r.id === editingRuleId ? { ...r, ...payload } : r)));

                setStatus({ type: 'success', message: 'Regra atualizada com sucesso.' });
            } else {
                const res = await agentApi.post(`/agent/api/v1/agent/${id}/rules/`, payload);

                setRules((prev) => [...prev, res.data]);

                setStatus({ type: 'success', message: 'Regra criada com sucesso.' });
            }

            fecharDialogRegra();
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: error.response?.data?.error || 'Erro ao salvar a regra.'
            });
        } finally {
            setSavingRule(false);
        }
    };

    const alternarRegraAtiva = async (rule) => {
        const novoValor = !rule.enabled;

        setSavingRuleEnabledId(rule.id);

        try {
            await agentApi.patch(`/agent/api/v1/agent/${id}/rules/${rule.id}/`, { enabled: novoValor });

            setRules((prev) => prev.map((r) => (r.id === rule.id ? { ...r, enabled: novoValor } : r)));
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao atualizar a regra.'
            });
        } finally {
            setSavingRuleEnabledId(null);
        }
    };

    const excluirRegra = async (ruleId) => {
        const confirmar = window.confirm('Deseja realmente excluir esta regra?');

        if (!confirmar) return;

        try {
            await agentApi.delete(`/agent/api/v1/agent/${id}/rules/${ruleId}/`);

            setRules((prev) => prev.filter((r) => r.id !== ruleId));

            setStatus({ type: 'success', message: 'Regra excluída com sucesso.' });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao excluir a regra.'
            });
        }
    };

    //? -------- Workflow (máquina de estados configurável - Fase 7) --------
    const recarregarWorkflow = async () => {
        if (!workflow) return;
        const detalhe = await agentApi.get(`/agent/api/v1/agent/${id}/workflows/${workflow.id}/`);
        setWorkflow(detalhe.data);
    };

    const criarWorkflow = async () => {
        setCreatingWorkflow(true);

        try {
            const res = await agentApi.post(`/agent/api/v1/agent/${id}/workflows/`, { name: 'Fluxo padrão' });

            setWorkflow({ ...res.data, states: [], transitions: [] });

            setStatus({ type: 'success', message: 'Workflow criado. Agora adicione estados e transições.' });
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: 'Erro ao criar workflow.' });
        } finally {
            setCreatingWorkflow(false);
        }
    };

    const alternarWorkflowAtivo = async () => {
        if (!workflow) return;

        const novoValor = !workflow.enabled;

        try {
            await agentApi.patch(`/agent/api/v1/agent/${id}/workflows/${workflow.id}/`, { enabled: novoValor });

            setWorkflow((prev) => ({ ...prev, enabled: novoValor }));
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: 'Erro ao atualizar o workflow.' });
        }
    };

    // -- Estados --

    const abrirCriarEstado = () => {
        setEditingStateId(null);
        setStateForm({ ...WORKFLOW_STATE_DEFAULT_FORM, order: (workflow?.states || []).length });
        setOpenStateDialog(true);
    };

    const abrirEditarEstado = (state) => {
        setEditingStateId(state.id);
        setStateForm({
            name: state.name || '',
            description: state.description || '',
            order: state.order ?? 0,
            is_initial: !!state.is_initial,
            is_final: !!state.is_final
        });
        setOpenStateDialog(true);
    };

    const fecharDialogEstado = () => {
        setOpenStateDialog(false);
        setEditingStateId(null);
        setStateForm(WORKFLOW_STATE_DEFAULT_FORM);
    };

    const estadoValido = Boolean(stateForm.name);

    const salvarEstado = async () => {
        if (!estadoValido || !workflow) return;

        setSavingState(true);

        const payload = { ...stateForm, order: Number(stateForm.order) || 0 };

        try {
            if (editingStateId) {
                await agentApi.patch(`/agent/api/v1/workflows/${workflow.id}/states/${editingStateId}/`, payload);
            } else {
                await agentApi.post(`/agent/api/v1/workflows/${workflow.id}/states/`, payload);
            }

            await recarregarWorkflow();

            setStatus({ type: 'success', message: 'Estado salvo com sucesso.' });

            fecharDialogEstado();
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: error.response?.data?.error || 'Erro ao salvar o estado.' });
        } finally {
            setSavingState(false);
        }
    };

    const excluirEstado = async (stateId) => {
        const confirmar = window.confirm('Excluir este estado? Transições ligadas a ele também serão removidas.');

        if (!confirmar) return;

        try {
            await agentApi.delete(`/agent/api/v1/workflows/${workflow.id}/states/${stateId}/`);

            await recarregarWorkflow();

            setStatus({ type: 'success', message: 'Estado excluído.' });
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: 'Erro ao excluir o estado.' });
        }
    };

    // -- Transições / Condições --

    const abrirCriarTransicao = () => {
        setEditingTransitionId(null);
        setTransitionForm(WORKFLOW_TRANSITION_DEFAULT_FORM);
        setTransitionConditions([{ condition_type: 'always', key: '', value: '' }]);
        setOpenTransitionDialog(true);
    };

    const abrirEditarTransicao = (transition) => {
        setEditingTransitionId(transition.id);
        setTransitionForm({
            from_state: transition.from_state || '',
            to_state: transition.to_state || '',
            name: transition.name || '',
            priority: transition.priority ?? 0,
            force_tool: transition.force_tool || '',
            enabled: transition.enabled !== false
        });
        setTransitionConditions(
            (transition.conditions || []).map((c) => ({
                condition_type: c.condition_type,
                key: c.key || '',
                value: Array.isArray(c.value) ? c.value.join(', ') : c.value === null || c.value === undefined ? '' : String(c.value)
            }))
        );
        setOpenTransitionDialog(true);
    };

    const fecharDialogTransicao = () => {
        setOpenTransitionDialog(false);
        setEditingTransitionId(null);
        setTransitionForm(WORKFLOW_TRANSITION_DEFAULT_FORM);
        setTransitionConditions([]);
    };

    const transicaoValida = Boolean(transitionForm.from_state && transitionForm.to_state);

    const adicionarCondicao = () => setTransitionConditions((prev) => [...prev, { condition_type: 'always', key: '', value: '' }]);

    const removerCondicao = (index) => setTransitionConditions((prev) => prev.filter((_, i) => i !== index));

    const atualizarCondicao = (index, field, value) =>
        setTransitionConditions((prev) => prev.map((c, i) => (i === index ? { ...c, [field]: value } : c)));

    const serializarValorCondicao = (condicao) => {
        const meta = CONDITION_TYPE_OPTIONS.find((o) => o.value === condicao.condition_type);

        if (!meta?.needsValue) return null;

        if (condicao.condition_type === 'message_keywords') {
            return condicao.value
                .split(',')
                .map((v) => v.trim())
                .filter(Boolean);
        }

        if (condicao.condition_type === 'message_regex') {
            return condicao.value;
        }

        // variable_equals / flag_equals: tenta JSON (permite true/false/números/"strings entre aspas"), senão usa o texto puro
        try {
            return JSON.parse(condicao.value);
        } catch (e) {
            return condicao.value;
        }
    };

    const salvarTransicao = async () => {
        if (!transicaoValida || !workflow) return;

        setSavingTransition(true);

        const payload = {
            from_state: transitionForm.from_state,
            to_state: transitionForm.to_state,
            name: transitionForm.name,
            priority: Number(transitionForm.priority) || 0,
            force_tool: transitionForm.force_tool,
            enabled: transitionForm.enabled
        };

        try {
            let transitionId = editingTransitionId;

            if (editingTransitionId) {
                await agentApi.patch(`/agent/api/v1/workflows/${workflow.id}/transitions/${editingTransitionId}/`, payload);

                // Substitui as condições antigas pelas do formulário - mais simples e
                // confiável que tentar diferenciar o que mudou campo a campo.
                const transicaoAtual = (workflow.transitions || []).find((t) => t.id === editingTransitionId);
                for (const condicaoAntiga of transicaoAtual?.conditions || []) {
                    await agentApi.delete(`/agent/api/v1/transitions/${editingTransitionId}/conditions/${condicaoAntiga.id}/`);
                }
            } else {
                const res = await agentApi.post(`/agent/api/v1/workflows/${workflow.id}/transitions/`, payload);
                transitionId = res.data.id;
            }

            for (const condicao of transitionConditions) {
                await agentApi.post(`/agent/api/v1/transitions/${transitionId}/conditions/`, {
                    condition_type: condicao.condition_type,
                    key: condicao.key,
                    value: serializarValorCondicao(condicao)
                });
            }

            await recarregarWorkflow();

            setStatus({ type: 'success', message: 'Transição salva com sucesso.' });

            fecharDialogTransicao();
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: error.response?.data?.error || 'Erro ao salvar a transição.' });
        } finally {
            setSavingTransition(false);
        }
    };

    const alternarTransicaoAtiva = async (transition) => {
        const novoValor = !transition.enabled;

        try {
            await agentApi.patch(`/agent/api/v1/workflows/${workflow.id}/transitions/${transition.id}/`, { enabled: novoValor });

            await recarregarWorkflow();
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: 'Erro ao atualizar a transição.' });
        }
    };

    const excluirTransicao = async (transitionId) => {
        const confirmar = window.confirm('Excluir esta transição?');

        if (!confirmar) return;

        try {
            await agentApi.delete(`/agent/api/v1/workflows/${workflow.id}/transitions/${transitionId}/`);

            await recarregarWorkflow();

            setStatus({ type: 'success', message: 'Transição excluída.' });
        } catch (error) {
            console.error(error);

            setStatus({ type: 'error', message: 'Erro ao excluir a transição.' });
        }
    };

    const formatDate = (iso) => {
        if (!iso) return '—';

        return new Date(iso).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const fetchDocumentos = async () => {
        if (!appId) return;

        try {
            const response = await api.get(`v1/apps/${appId}/agents/${id}/knowledge_documents/`);
            setDocumentos(response.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDocumentos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, id]);

    const handleFileUpload = async (e) => {
        const files = Array.from(e.target.files || []);
        e.target.value = '';
        if (files.length === 0) return;

        setUploading(true);

        try {
            for (const file of files) {
                const formData = new FormData();
                formData.append('file', file);

                try {
                    const response = await api.post(`v1/apps/${appId}/agents/${id}/knowledge_documents/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });

                    if (response.data?.warning) {
                        setStatus({ type: 'error', message: `"${file.name}": ${response.data.warning}` });
                    }
                } catch (error) {
                    console.error(error);
                    const mensagemErro = error.response?.data?.error || `Erro ao enviar "${file.name}".`;
                    setStatus({ type: 'error', message: mensagemErro });
                }
            }

            await fetchDocumentos();
            setStatus((prev) =>
                prev.type === 'error' ? prev : { type: 'success', message: 'Documento(s) enviado(s) e sincronizado(s) com o agente.' }
            );
        } finally {
            setUploading(false);
        }
    };

    const handleDeleteDocumento = async (documentoId) => {
        const confirmDelete = window.confirm('Deseja realmente excluir este documento da base de conhecimento?');
        if (!confirmDelete) return;

        setDeletingDocumentoId(documentoId);

        try {
            await api.delete(`v1/apps/${appId}/agents/${id}/knowledge_documents/${documentoId}/`);
            setDocumentos((prev) => prev.filter((d) => d.id !== documentoId));
            setStatus({ type: 'success', message: 'Documento removido.' });
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao excluir documento.' });
        } finally {
            setDeletingDocumentoId(null);
        }
    };

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    py: 10
                }}
            >
                <CircularProgress size={48} />
            </Box>
        );
    }

    if (!agent) {
        return <Alert severity="error">Não foi possível carregar o agente.</Alert>;
    }

    const typeConfig = AGENT_TYPES[agent.agent_type] || {
        label: agent.agent_type,
        color: '#455a64',
        bg: 'linear-gradient(135deg, #eceff1, #cfd8dc)',
        border: '#b0bec5',
        Icon: IconRobot
    };

    const AgentIcon = typeConfig.Icon;

    return (
        <Box>
            {/* HEADER */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 4
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Button
                        variant="outlined"
                        startIcon={<IconArrowLeft size={18} />}
                        onClick={() => history.goBack()}
                        sx={{
                            borderRadius: '12px',
                            textTransform: 'none'
                        }}
                    >
                        Voltar
                    </Button>

                    <Box>
                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: 800,
                                background: 'linear-gradient(90deg, #1976d2, #9c27b0)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                lineHeight: 1.2
                            }}
                        >
                            {agent.name}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                mt: 0.5
                            }}
                        >
                            Detalhes do agente e ferramentas configuradas
                        </Typography>
                    </Box>
                </Box>

                <Button
                    variant="outlined"
                    startIcon={<IconActivity size={18} />}
                    onClick={() => history.push(`/dashboard/config/agent/traces/${id}`)}
                    sx={{
                        borderRadius: '12px',
                        textTransform: 'none'
                    }}
                >
                    Ver execuções
                </Button>
            </Box>

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mb: 3,
                        borderRadius: '12px'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            {/* CARD PRINCIPAL */}
            <Card
                sx={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                    border: `1px solid ${typeConfig.border}`,
                    mb: 4
                }}
            >
                <Box
                    sx={{
                        background: typeConfig.bg,
                        p: 4,
                        display: 'flex',
                        gap: 3,
                        alignItems: 'flex-start',
                        flexWrap: 'wrap'
                    }}
                >
                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: '18px',
                            background: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: `0 6px 20px ${typeConfig.border}`
                        }}
                    >
                        <AgentIcon size={38} color={typeConfig.color} />
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 260 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            {editingAgent ? (
                                <TextField
                                    value={agentForm.name}
                                    onChange={(e) =>
                                        setAgentForm({
                                            ...agentForm,
                                            name: e.target.value
                                        })
                                    }
                                    size="small"
                                />
                            ) : (
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontWeight: 800
                                    }}
                                >
                                    {agent.name}
                                </Typography>
                            )}

                            <IconButton size="small" onClick={() => setEditingAgent(!editingAgent)}>
                                <IconEdit size={18} />
                            </IconButton>
                        </Box>

                        <Chip
                            label={typeConfig.label}
                            sx={{
                                backgroundColor: '#fff',
                                color: typeConfig.color,
                                border: `1px solid ${typeConfig.border}`,
                                fontWeight: 700,
                                mb: 2
                            }}
                        />

                        {editingAgent ? (
                            <TextField
                                fullWidth
                                multiline
                                rows={6}
                                value={agentForm.system_prompt}
                                onChange={(e) =>
                                    setAgentForm({
                                        ...agentForm,
                                        system_prompt: e.target.value
                                    })
                                }
                            />
                        ) : (
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#424242',
                                    lineHeight: 1.8
                                }}
                            >
                                {agent.system_prompt}
                            </Typography>
                        )}
                    </Box>
                </Box>

                <Divider />

                <CardContent sx={{ p: 3 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: '16px',
                                    background: '#f8fafc',
                                    border: '1px solid #e2e8f0'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: 'text.secondary',
                                        display: 'block',
                                        mb: 1
                                    }}
                                >
                                    Tipo do agente
                                </Typography>

                                <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                    {editingAgent ? (
                                        <TextField
                                            select
                                            fullWidth
                                            value={agentForm.agent_type}
                                            onChange={(e) =>
                                                setAgentForm({
                                                    ...agentForm,

                                                    agent_type: e.target.value
                                                })
                                            }
                                        >
                                            {Object.entries(AGENT_TYPES).map(([key, value]) => (
                                                <MenuItem key={key} value={key}>
                                                    {value.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    ) : (
                                        typeConfig.label
                                    )}
                                </Typography>

                                {editingAgent && (
                                    <Box sx={{ mt: 3 }}>
                                        <Button
                                            variant="contained"
                                            startIcon={<IconDeviceFloppy size={18} />}
                                            onClick={salvarAgente}
                                            sx={{
                                                borderRadius: '12px',
                                                textTransform: 'none'
                                            }}
                                        >
                                            Salvar alterações
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: '16px',
                                    background: '#f8fafc',
                                    border: '1px solid #e2e8f0'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: 'text.secondary',
                                        display: 'block',
                                        mb: 1
                                    }}
                                >
                                    Quantidade de ferramentas
                                </Typography>

                                <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                    {tools.length}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: '16px',
                                    background: '#f8fafc',
                                    border: '1px solid #e2e8f0'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: 'text.secondary',
                                        display: 'block',
                                        mb: 1
                                    }}
                                >
                                    Criado em
                                </Typography>

                                <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                    {formatDate(agent.created_at)}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* CANAIS ATENDIDOS */}
            <Box sx={{ mb: 2 }}>
                <Typography variant="h3" sx={{ fontWeight: 800, mb: 1, mt: 1 }}>
                    Canais atendidos
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Marque quais canais este agente responde. Cada canal só pode ser respondido por um agente por vez.
                </Typography>
            </Box>

            <Card
                sx={{
                    borderRadius: '20px',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                    border: '1px solid #e2e8f0',
                    mb: 4
                }}
            >
                <CardContent sx={{ p: 3 }}>
                    {canais.length === 0 ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: 'text.secondary' }}>
                            <IconPlugConnected size={20} />
                            <Typography variant="body2">Nenhum canal cadastrado ainda em Configurações &gt; Canais.</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={1}>
                            {canais.map((canal) => {
                                const atribuidoAEsteAgente = String(canal.webhook_agent_id || '') === String(id);
                                const atribuidoAOutroAgente = canal.webhook_agent_id && !atribuidoAEsteAgente;

                                return (
                                    <Grid item xs={12} sm={6} md={4} key={canal.id}>
                                        <Box
                                            sx={{
                                                p: 1.5,
                                                borderRadius: '12px',
                                                border: '1px solid #e2e8f0',
                                                background: atribuidoAEsteAgente ? '#e3f2fd' : '#f8fafc',
                                                height: '100%'
                                            }}
                                        >
                                            <FormControlLabel
                                                sx={{ width: '100%', m: 0 }}
                                                control={
                                                    <Checkbox
                                                        checked={atribuidoAEsteAgente}
                                                        disabled={atribuidoAOutroAgente || savingCanalId === canal.id}
                                                        onChange={() => toggleCanal(canal)}
                                                    />
                                                }
                                                label={
                                                    <Box sx={{ minWidth: 0 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
                                                            {canal.displayName}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                            {canal.type}
                                                        </Typography>
                                                        {atribuidoAOutroAgente && (
                                                            <Typography variant="caption" sx={{ display: 'block', color: '#d32f2f' }}>
                                                                Atribuído a: {nomeDoAgenteResponsavel(canal.webhook_agent_id)}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                }
                                            />
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                </CardContent>
            </Card>

            <Divider />

            <CardContent sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    <Button
                        variant="contained"
                        startIcon={<IconPlus size={18} />}
                        component="label"
                        // ml={2}
                        sx={{
                            borderRadius: '12px',
                            px: 3,
                            py: 1.2,
                            mt: 1,
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '0.9rem',
                            background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                            boxShadow: '0 8px 20px rgba(25,118,210,0.3)',
                            transition: 'all 0.3s',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 12px 25px rgba(25,118,210,0.45)'
                            }
                        }}
                        disabled={uploading}
                    >
                        {uploading ? 'Enviando...' : 'Adicionar arquivo'}
                        <input type="file" accept=".txt,.md,.json,.pdf,.docx" hidden multiple onChange={handleFileUpload} />
                    </Button>
                </Grid>

                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1.5 }}>
                    Formatos aceitos: .txt, .md, .json, .pdf, .docx — o texto é extraído e sincronizado com o agente automaticamente.
                </Typography>
            </CardContent>

            {/* BASE CONHECIMENTO */}
            <Box sx={{ mb: 2 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 800,
                        mb: 1,
                        mt: 1
                    }}
                >
                    Base de Conhecimento
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary'
                    }}
                >
                    Todas as bases de conhecimento disponíveis para este agente.
                </Typography>
            </Box>

            {documentos.length === 0 ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 8,
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #f8f9ff, #f0f4ff)',
                        border: '2px dashed #c5cae9'
                    }}
                >
                    <IconFileUnknownFilled size={54} color="#9fa8da" style={{ marginBottom: 12 }} />

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#5c6bc0',
                            mb: 1
                        }}
                    >
                        Nenhuma documento cadastrado
                    </Typography>

                    <Typography variant="body2">Este agente ainda não possui base de conhecimento configurada.</Typography>
                </Box>
            ) : (
                <Grid container spacing={2}>
                    {documentos.map((documento) => (
                        <Grid item xs={12} key={documento.id}>
                            <Card>
                                <CardContent
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 2
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                                        <IconFileUnknownFilled size={22} color="#9fa8da" />
                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body1" sx={{ fontWeight: 600 }} noWrap>
                                                {documento.filename}
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.5 }}
                                            >
                                                <IconCalendar size={13} />
                                                {formatDate(documento.created_at)}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <IconButton
                                        size="small"
                                        color="error"
                                        disabled={deletingDocumentoId === documento.id}
                                        onClick={() => handleDeleteDocumento(documento.id)}
                                    >
                                        <IconTrash size={18} />
                                    </IconButton>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            <Divider sx={{ mt: 2 }} />

            <CardContent sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    <Button
                        variant="contained"
                        startIcon={<IconPlus size={18} />}
                        onClick={() => history.push(`/dashboard/config/agent/tool/create/${id}`)}
                        sx={{
                            borderRadius: '12px',
                            px: 3,
                            py: 1.2,
                            mt: 2,
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '0.9rem',
                            background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                            boxShadow: '0 8px 20px rgba(25,118,210,0.3)',
                            transition: 'all 0.3s',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 12px 25px rgba(25,118,210,0.45)'
                            }
                        }}
                    >
                        Criar Ferramenta
                    </Button>
                </Grid>
            </CardContent>

            {/* TOOLS */}
            <Box sx={{ mb: 2 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 800,
                        mb: 1,
                        mt: 1
                    }}
                >
                    Ferramentas do Agente
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary'
                    }}
                >
                    Todas as ferramentas disponíveis para este agente executar
                </Typography>
            </Box>

            {tools.length === 0 ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 8,
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #f8f9ff, #f0f4ff)',
                        border: '2px dashed #c5cae9'
                    }}
                >
                    <IconTool size={54} color="#9fa8da" style={{ marginBottom: 12 }} />

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#5c6bc0',
                            mb: 1
                        }}
                    >
                        Nenhuma ferramenta cadastrada
                    </Typography>

                    <Typography variant="body2">Este agente ainda não possui ferramentas configuradas.</Typography>
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {tools.map((tool) => (
                        <Grid item xs={12} key={tool.id}>
                            <Card
                                onClick={() => history.push(`/dashboard/config/agent/tool/${tool.id}`)}
                                sx={{
                                    cursor: 'pointer',
                                    transition: '0.2s',
                                    '&:hover': {
                                        transform: 'translateY(-3px)',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.12)'
                                    }
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            flexWrap: 'wrap',
                                            gap: 2,
                                            mb: 2
                                        }}
                                    >
                                        <Box sx={{ flex: 1, minWidth: 200 }}>
                                            {editingToolId === tool.id ? (
                                                <TextField
                                                    fullWidth
                                                    value={toolDraft.name}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={(e) =>
                                                        setToolDraft({
                                                            ...toolDraft,
                                                            name: e.target.value
                                                        })
                                                    }
                                                    sx={{ mb: 1 }}
                                                />
                                            ) : (
                                                <Typography
                                                    variant="h4"
                                                    sx={{
                                                        fontWeight: 800,
                                                        mb: 1
                                                    }}
                                                >
                                                    {tool.name}
                                                </Typography>
                                            )}

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: 1,
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <Chip
                                                    icon={<IconBolt size={14} />}
                                                    label={tool.execution_type}
                                                    color="primary"
                                                    variant="outlined"
                                                />

                                                <Chip icon={<IconUser size={14} />} label={tool.type_user} variant="outlined" />
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: '#9e9e9e',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                    mr: 1
                                                }}
                                            >
                                                <IconCalendar size={14} />
                                                {formatDate(tool.created_at)}
                                            </Typography>

                                            {editingToolId === tool.id ? (
                                                <>
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        disabled={savingTool}
                                                        onClick={(e) => salvarTool(tool.id, e)}
                                                    >
                                                        <IconDeviceFloppy size={18} />
                                                    </IconButton>

                                                    <IconButton size="small" disabled={savingTool} onClick={cancelarEdicaoTool}>
                                                        <IconX size={18} />
                                                    </IconButton>
                                                </>
                                            ) : (
                                                <>
                                                    <IconButton size="small" onClick={(e) => iniciarEdicaoTool(tool, e)}>
                                                        <IconEdit size={18} />
                                                    </IconButton>

                                                    <IconButton size="small" color="error" onClick={(e) => excluirTool(tool.id, e)}>
                                                        <IconTrash size={18} />
                                                    </IconButton>
                                                </>
                                            )}
                                        </Box>
                                    </Box>

                                    <Divider sx={{ mb: 2 }} />

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    fontWeight: 700,
                                                    mb: 1
                                                }}
                                            >
                                                Descrição
                                            </Typography>

                                            {editingToolId === tool.id ? (
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    value={toolDraft.description}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={(e) =>
                                                        setToolDraft({
                                                            ...toolDraft,
                                                            description: e.target.value
                                                        })
                                                    }
                                                />
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: 'text.secondary',
                                                        lineHeight: 1.8
                                                    }}
                                                >
                                                    {tool.description}
                                                </Typography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    fontWeight: 700,
                                                    mb: 1
                                                }}
                                            >
                                                Prompt de ativação
                                            </Typography>

                                            {editingToolId === tool.id ? (
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    value={toolDraft.prompt}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={(e) =>
                                                        setToolDraft({
                                                            ...toolDraft,
                                                            prompt: e.target.value
                                                        })
                                                    }
                                                />
                                            ) : (
                                                <Box
                                                    sx={{
                                                        background: '#0f172a',
                                                        color: '#fff',
                                                        p: 2,
                                                        borderRadius: '12px',
                                                        fontFamily: 'monospace',
                                                        fontSize: '0.85rem'
                                                    }}
                                                >
                                                    {tool.prompt}
                                                </Box>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    fontWeight: 700,
                                                    mb: 1
                                                }}
                                            >
                                                Endpoint
                                            </Typography>

                                            <Box
                                                sx={{
                                                    background: '#f8fafc',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    p: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    overflowX: 'auto'
                                                }}
                                            >
                                                <IconWorld size={18} color="#64748b" />

                                                {editingToolId === tool.id ? (
                                                    <TextField
                                                        fullWidth
                                                        value={toolDraft.endpoint}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) =>
                                                            setToolDraft({
                                                                ...toolDraft,
                                                                endpoint: e.target.value
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontFamily: 'monospace',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {tool.endpoint}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* REGRAS DE FLUXO */}
            <Box sx={{ mb: 2, mt: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 2 }}>
                <Box>
                    <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
                        Regras de Fluxo
                    </Typography>

                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Controla qual ferramenta é forçada e para qual estado a conversa avança, conforme o estado atual e a mensagem do
                        cliente.
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    startIcon={<IconPlus size={18} />}
                    onClick={abrirCriarRegra}
                    sx={{
                        borderRadius: '12px',
                        px: 3,
                        py: 1.2,
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                        boxShadow: '0 8px 20px rgba(25,118,210,0.3)'
                    }}
                >
                    Nova regra
                </Button>
            </Box>

            {regrasOrdenadas.length === 0 ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 8,
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #f8f9ff, #f0f4ff)',
                        border: '2px dashed #c5cae9'
                    }}
                >
                    <IconArrowsRightLeft size={54} color="#9fa8da" style={{ marginBottom: 12 }} />

                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#5c6bc0', mb: 1 }}>
                        Nenhuma regra cadastrada
                    </Typography>

                    <Typography variant="body2">Este agente ainda não possui regras de fluxo configuradas.</Typography>
                </Box>
            ) : (
                <Card sx={{ borderRadius: '20px', boxShadow: '0 8px 30px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' }}>
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Nome</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Estado</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Gatilho</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Tool forçada</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align="center">
                                        Ordem
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align="center">
                                        Ativo
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align="right">
                                        Ações
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {regrasOrdenadas.map((rule) => (
                                    <TableRow key={rule.id} hover>
                                        <TableCell sx={{ fontWeight: 600 }}>{rule.name}</TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
                                                <Chip size="small" label={rule.from_state} variant="outlined" />
                                                <IconChevronRight size={14} color="#94a3b8" />
                                                <Chip size="small" label={rule.to_state} variant="outlined" />
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={
                                                    TRIGGER_TYPE_OPTIONS.find((o) => o.value === rule.trigger_type)?.label ||
                                                    rule.trigger_type
                                                }
                                                color={rule.trigger_type === 'always' ? 'default' : 'primary'}
                                                variant="outlined"
                                            />
                                            {rule.trigger_type !== 'always' && rule.trigger_value && (
                                                <Tooltip title={rule.trigger_value}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            display: 'block',
                                                            color: 'text.secondary',
                                                            maxWidth: 220,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {rule.trigger_value}
                                                    </Typography>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                                                {rule.force_tool}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">{rule.order}</TableCell>
                                        <TableCell align="center">
                                            <Switch
                                                size="small"
                                                checked={rule.enabled !== false}
                                                disabled={savingRuleEnabledId === rule.id}
                                                onChange={() => alternarRegraAtiva(rule)}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton size="small" onClick={() => abrirEditarRegra(rule)}>
                                                <IconEdit size={18} />
                                            </IconButton>

                                            <IconButton size="small" color="error" onClick={() => excluirRegra(rule.id)}>
                                                <IconTrash size={18} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Card>
            )}

            {/* DIALOG CRIAR/EDITAR REGRA */}
            <Dialog open={openRuleDialog} onClose={fecharDialogRegra} fullWidth maxWidth="sm">
                <DialogTitle>{editingRuleId ? 'Editar regra' : 'Nova regra de fluxo'}</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Nome"
                                value={ruleForm.name}
                                onChange={(e) => setRuleForm({ ...ruleForm, name: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Estado origem (from_state)"
                                placeholder="initial"
                                helperText='Toda conversa começa em "initial"'
                                value={ruleForm.from_state}
                                onChange={(e) => setRuleForm({ ...ruleForm, from_state: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Estado destino (to_state)"
                                placeholder="fluxo_livre"
                                value={ruleForm.to_state}
                                onChange={(e) => setRuleForm({ ...ruleForm, to_state: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label="Tipo de gatilho"
                                value={ruleForm.trigger_type}
                                onChange={(e) => setRuleForm({ ...ruleForm, trigger_type: e.target.value })}
                            >
                                {TRIGGER_TYPE_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Ordem"
                                helperText="Menor número = maior prioridade"
                                value={ruleForm.order}
                                onChange={(e) => setRuleForm({ ...ruleForm, order: e.target.value })}
                            />
                        </Grid>

                        {ruleForm.trigger_type !== 'always' && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    label="Valor do gatilho"
                                    placeholder={
                                        ruleForm.trigger_type === 'keywords' ? 'oi, olá, bom dia, boa tarde, boa noite' : '^(oi|ol[aá])\\b'
                                    }
                                    helperText={
                                        ruleForm.trigger_type === 'keywords'
                                            ? 'Palavras separadas por vírgula - dispara se a mensagem contiver qualquer uma delas'
                                            : 'Padrão regex - dispara se a mensagem bater com o padrão'
                                    }
                                    value={ruleForm.trigger_value}
                                    onChange={(e) => setRuleForm({ ...ruleForm, trigger_value: e.target.value })}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Tool forçada (force_tool)"
                                placeholder="envia_saudacao"
                                helperText="Nome da ferramenta a ser executada quando a regra disparar"
                                value={ruleForm.force_tool}
                                onChange={(e) => setRuleForm({ ...ruleForm, force_tool: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={ruleForm.enabled}
                                        onChange={(e) => setRuleForm({ ...ruleForm, enabled: e.target.checked })}
                                    />
                                }
                                label="Regra ativa"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={fecharDialogRegra}>Cancelar</Button>
                    <Button variant="contained" disabled={!regraValida || savingRule} onClick={salvarRegra}>
                        {editingRuleId ? 'Salvar alterações' : 'Criar regra'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* WORKFLOW (MÁQUINA DE ESTADOS) */}
            <Box sx={{ mb: 2, mt: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 2 }}>
                <Box>
                    <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
                        Workflow (Máquina de Estados)
                    </Typography>

                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Define os estados possíveis da conversa e as transições entre eles. Enquanto ativo, tem prioridade sobre as Regras
                        de Fluxo acima para este agente.
                    </Typography>
                </Box>

                {workflow && (
                    <FormControlLabel
                        control={<Switch checked={workflow.enabled} onChange={alternarWorkflowAtivo} />}
                        label={workflow.enabled ? 'Workflow ativo' : 'Workflow desativado'}
                    />
                )}
            </Box>

            {!workflow ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 8,
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #f8f9ff, #f0f4ff)',
                        border: '2px dashed #c5cae9'
                    }}
                >
                    <IconArrowsRightLeft size={54} color="#9fa8da" style={{ marginBottom: 12 }} />

                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#5c6bc0', mb: 1 }}>
                        Nenhum workflow configurado
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Sem um workflow, este agente continua usando as Regras de Fluxo (acima), se houver.
                    </Typography>

                    <Button
                        variant="contained"
                        disabled={creatingWorkflow}
                        onClick={criarWorkflow}
                        sx={{ borderRadius: '12px', textTransform: 'none' }}
                    >
                        Criar workflow
                    </Button>
                </Box>
            ) : (
                <>
                    {/* ESTADOS */}
                    <Box sx={{ mb: 2, mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            Estados
                        </Typography>

                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<IconPlus size={16} />}
                            onClick={abrirCriarEstado}
                            sx={{ borderRadius: '10px', textTransform: 'none' }}
                        >
                            Novo estado
                        </Button>
                    </Box>

                    {(workflow.states || []).length === 0 ? (
                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                            Nenhum estado cadastrado ainda.
                        </Typography>
                    ) : (
                        <Card sx={{ borderRadius: '16px', border: '1px solid #e2e8f0', mb: 4 }}>
                            <Box sx={{ overflowX: 'auto' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>Nome</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Descrição</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="center">
                                                Ordem
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="center">
                                                Inicial
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="center">
                                                Final
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="right">
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[...(workflow.states || [])]
                                            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                                            .map((state) => (
                                                <TableRow key={state.id} hover>
                                                    <TableCell sx={{ fontWeight: 600, fontFamily: 'monospace' }}>{state.name}</TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: 'text.secondary',
                                                                maxWidth: 320,
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {state.description || '—'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">{state.order}</TableCell>
                                                    <TableCell align="center">
                                                        {state.is_initial && <Chip size="small" color="primary" label="Inicial" />}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {state.is_final && <Chip size="small" color="secondary" label="Final" />}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <IconButton size="small" onClick={() => abrirEditarEstado(state)}>
                                                            <IconEdit size={18} />
                                                        </IconButton>

                                                        <IconButton size="small" color="error" onClick={() => excluirEstado(state.id)}>
                                                            <IconTrash size={18} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Card>
                    )}

                    {/* TRANSIÇÕES */}
                    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            Transições
                        </Typography>

                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<IconPlus size={16} />}
                            onClick={abrirCriarTransicao}
                            disabled={(workflow.states || []).length < 2}
                            sx={{ borderRadius: '10px', textTransform: 'none' }}
                        >
                            Nova transição
                        </Button>
                    </Box>

                    {(workflow.states || []).length < 2 && (
                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                            Cadastre pelo menos dois estados para criar uma transição.
                        </Typography>
                    )}

                    {(workflow.transitions || []).length === 0 ? (
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Nenhuma transição cadastrada ainda.
                        </Typography>
                    ) : (
                        <Card sx={{ borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                            <Box sx={{ overflowX: 'auto' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>Estados</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Condições</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Tool forçada</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="center">
                                                Prioridade
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="center">
                                                Ativa
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 700 }} align="right">
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[...(workflow.transitions || [])]
                                            .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
                                            .map((transition) => (
                                                <TableRow key={transition.id} hover>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
                                                            <Chip size="small" label={transition.from_state_name} variant="outlined" />
                                                            <IconChevronRight size={14} color="#94a3b8" />
                                                            <Chip size="small" label={transition.to_state_name} variant="outlined" />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        {(transition.conditions || []).length === 0 ? (
                                                            <Typography variant="caption" sx={{ color: 'error.main' }}>
                                                                sem condição (nunca dispara)
                                                            </Typography>
                                                        ) : (
                                                            (transition.conditions || []).map((c) => (
                                                                <Chip
                                                                    key={c.id}
                                                                    size="small"
                                                                    sx={{ mr: 0.5, mb: 0.5 }}
                                                                    label={
                                                                        CONDITION_TYPE_OPTIONS.find((o) => o.value === c.condition_type)
                                                                            ?.label || c.condition_type
                                                                    }
                                                                />
                                                            ))
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                                                            {transition.force_tool || '—'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">{transition.priority}</TableCell>
                                                    <TableCell align="center">
                                                        <Switch
                                                            size="small"
                                                            checked={transition.enabled !== false}
                                                            onChange={() => alternarTransicaoAtiva(transition)}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <IconButton size="small" onClick={() => abrirEditarTransicao(transition)}>
                                                            <IconEdit size={18} />
                                                        </IconButton>

                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() => excluirTransicao(transition.id)}
                                                        >
                                                            <IconTrash size={18} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Card>
                    )}
                </>
            )}

            {/* DIALOG CRIAR/EDITAR ESTADO */}
            <Dialog open={openStateDialog} onClose={fecharDialogEstado} fullWidth maxWidth="sm">
                <DialogTitle>{editingStateId ? 'Editar estado' : 'Novo estado'}</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Nome"
                                placeholder="QUALIFY"
                                value={stateForm.name}
                                onChange={(e) => setStateForm({ ...stateForm, name: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={2}
                                label="Descrição"
                                helperText="Explica pro modelo o que esse estado significa"
                                value={stateForm.description}
                                onChange={(e) => setStateForm({ ...stateForm, description: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Ordem"
                                helperText="Só para organização visual"
                                value={stateForm.order}
                                onChange={(e) => setStateForm({ ...stateForm, order: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={stateForm.is_initial}
                                        onChange={(e) => setStateForm({ ...stateForm, is_initial: e.target.checked })}
                                    />
                                }
                                label="Estado inicial"
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={stateForm.is_final}
                                        onChange={(e) => setStateForm({ ...stateForm, is_final: e.target.checked })}
                                    />
                                }
                                label="Estado final"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={fecharDialogEstado}>Cancelar</Button>
                    <Button variant="contained" disabled={!estadoValido || savingState} onClick={salvarEstado}>
                        {editingStateId ? 'Salvar alterações' : 'Criar estado'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* DIALOG CRIAR/EDITAR TRANSIÇÃO */}
            <Dialog open={openTransitionDialog} onClose={fecharDialogTransicao} fullWidth maxWidth="md">
                <DialogTitle>{editingTransitionId ? 'Editar transição' : 'Nova transição'}</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label="Estado origem"
                                value={transitionForm.from_state}
                                onChange={(e) => setTransitionForm({ ...transitionForm, from_state: e.target.value })}
                            >
                                {(workflow?.states || []).map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label="Estado destino"
                                value={transitionForm.to_state}
                                onChange={(e) => setTransitionForm({ ...transitionForm, to_state: e.target.value })}
                            >
                                {(workflow?.states || []).map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Nome (opcional)"
                                value={transitionForm.name}
                                onChange={(e) => setTransitionForm({ ...transitionForm, name: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Prioridade"
                                helperText="Menor = avaliada primeiro"
                                value={transitionForm.priority}
                                onChange={(e) => setTransitionForm({ ...transitionForm, priority: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={transitionForm.enabled}
                                        onChange={(e) => setTransitionForm({ ...transitionForm, enabled: e.target.checked })}
                                    />
                                }
                                label="Ativa"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Tool forçada (opcional)"
                                placeholder="buscar_imoveis"
                                helperText="Nome exato de uma tool a executar quando a transição disparar"
                                value={transitionForm.force_tool}
                                onChange={(e) => setTransitionForm({ ...transitionForm, force_tool: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    Condições (todas precisam bater)
                                </Typography>

                                <Button
                                    size="small"
                                    startIcon={<IconPlus size={16} />}
                                    onClick={adicionarCondicao}
                                    sx={{ textTransform: 'none' }}
                                >
                                    Adicionar condição
                                </Button>
                            </Box>

                            {transitionConditions.length === 0 && (
                                <Typography variant="body2" sx={{ color: 'error.main', mb: 1 }}>
                                    Sem nenhuma condição, esta transição nunca vai disparar.
                                </Typography>
                            )}

                            {transitionConditions.map((condicao, index) => {
                                const meta = CONDITION_TYPE_OPTIONS.find((o) => o.value === condicao.condition_type);

                                return (
                                    <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', mb: 1.5, flexWrap: 'wrap' }}>
                                        <TextField
                                            select
                                            label="Tipo"
                                            sx={{ minWidth: 240 }}
                                            value={condicao.condition_type}
                                            onChange={(e) => atualizarCondicao(index, 'condition_type', e.target.value)}
                                        >
                                            {CONDITION_TYPE_OPTIONS.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>

                                        {meta?.needsKey && (
                                            <TextField
                                                label="Nome"
                                                placeholder="ex: email, aceitou_termos, buscar_imoveis"
                                                sx={{ minWidth: 200 }}
                                                value={condicao.key}
                                                onChange={(e) => atualizarCondicao(index, 'key', e.target.value)}
                                            />
                                        )}

                                        {meta?.needsValue && (
                                            <TextField
                                                label="Valor"
                                                placeholder={meta.valueHint}
                                                sx={{ minWidth: 220, flexGrow: 1 }}
                                                value={condicao.value}
                                                onChange={(e) => atualizarCondicao(index, 'value', e.target.value)}
                                            />
                                        )}

                                        <IconButton size="small" color="error" onClick={() => removerCondicao(index)} sx={{ mt: 1 }}>
                                            <IconTrash size={18} />
                                        </IconButton>
                                    </Box>
                                );
                            })}
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={fecharDialogTransicao}>Cancelar</Button>
                    <Button variant="contained" disabled={!transicaoValida || savingTransition} onClick={salvarTransicao}>
                        {editingTransitionId ? 'Salvar alterações' : 'Criar transição'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ViewDetailAgents;
